/**
 * The theme as it is RIGHT NOW, watching <html data-theme> rather than
 * reading it once.
 *
 * Shared by every surface that hands the theme to a sandboxed document
 * (insight cards, insight-pack pages): those frames have an opaque origin
 * where localStorage throws, so the host passes the theme in the URL and by
 * postMessage — and both need the live value, not a stale read. Lives apart
 * from theme.ts on purpose: that is the plain module main.tsx boots the
 * theme with before first render, and it stays React-free.
 */
import { useEffect, useState } from 'react'

import { DEFAULT_THEME, type Theme } from './theme'

export function useCurrentTheme(): Theme {
  const read = (): Theme =>
    document.documentElement.getAttribute('data-theme') === 'light'
      ? 'light' : DEFAULT_THEME

  const [theme, setTheme] = useState<Theme>(read)
  useEffect(() => {
    const observer = new MutationObserver(() => setTheme(read()))
    observer.observe(document.documentElement,
                     { attributes: true, attributeFilter: ['data-theme'] })
    return () => observer.disconnect()
  }, [])
  return theme
}
